import { Component } from 'react';
import { inject, observer } from 'mobx-react';

//components
import applicationRouter from '~/hoc/applicationRouter';
import withLocalization from '~/hoc/withLocalization';
import Button from '../../../components/CustomButton/CustomButton';
import ManageGroups from './UserGroupManagement';
import PermissionGroups from './PermissionGroups/PermissionGroups';

//styles
import '../Roster/RosterScheduler/css/workPatternStyle.css';

const TABS = [
    { key: 'groups', label: 'Manage Groups' },
    { key: 'permissions', label: 'Permission Groups' },
];

/**
 * Page behind Members -> More Actions -> Manage Groups.
 * Admins get both tabs; PMs only get the group list, so the Permission Groups tab is hidden for them.
 */
class UserGroupsPage extends Component {
    state = { activeTab: 'groups' };

    componentDidMount() {
        const { router } = this.props;
        if (!this.isAdmin()) return;
        if (router.location?.state?.tab) this.setState({ activeTab: router.location.state.tab });
    }

    isAdmin = () => this.props.userStore.currentUser?.user_type === 'admin';

    renderTab = () => {
        return this.isAdmin() && this.state.activeTab === 'permissions' ? <PermissionGroups /> : <ManageGroups />;
    };

    render() {
        const { t, router, commonStore } = this.props;
        const { activeTab } = this.state;
        const isAdmin = this.isAdmin();
        // read the observable locale so this observer re-renders on a language switch
        // eslint-disable-next-line no-unused-vars
        const locale = commonStore.locale;
        return (
            <div className="px-3">
                <div
                    className="d-flex align-items-center justify-content-between flex-wrap gap-2 py-3 position-sticky top-0 bg-white border-bottom"
                    style={{ zIndex: 10 }}
                >
                    <Button onClick={() => router.navigate('/admin/members')}>
                        <i className="fas fa-arrow-left me-2" aria-hidden="true" />
                        {t('Back')}
                    </Button>
                    {isAdmin && <div className="d-flex rounded-2 overflow-hidden">
                        {TABS.map((tab, index) => (
                            <button
                                key={tab.key}
                                type="button"
                                className={`tab-btn${index === 0 ? ' tab-btn-left' : ' tab-btn-right'}${activeTab === tab.key ? ' active' : ''}`}
                                onClick={() => this.setState({ activeTab: tab.key })}
                            >
                                {t(tab.label)}
                            </button>
                        ))}
                    </div>}
                </div>
                <div className="pt-3">{this.renderTab()}</div>
            </div>
        );
    }
}

export default inject('userStore', 'commonStore')(applicationRouter(withLocalization(observer(UserGroupsPage))));
